export const adminCreateUser = {
  first_name: {
    presence: true,
    length: {
      maximum: 20,
    }
  },
  last_name: {
    presence: true,
    length: {
      maximum: 20,
    }
  },
  email: {
    presence: true,
    email: {
      message: '^Email is not valid'
    },
  },
  email_confirmation: {
    presence: true,
    equality: {
      attribute: "email",
      message: '^Email confirmation is not the same as the email specified'
    }
  },
  password: {
    presence: true,
    length: {
      minimum: 7,
      message: "^Min 7 characters with at least 1 number and capital letter"
    },
    format: {
      pattern: /(.*\d.*[A-Z].*)|.*[A-Z].*\d.*/,
      message: "^Min 7 characters with at least 1 number and capital letter"
    },
  }
}



// WEBPACK FOOTER //
// ./src/validators/adminCreateUser.js